import React, { useContext } from 'react'
import { IntakeContext } from 'context/IntakeContext'
import { Box, Grid, Typography, Button } from '@mui/material'
import { riskProfiles } from './risk-profiles'
import { useRPQScore } from 'layouts/authenticated/pages/dashboard/hooks/useRPQScore'

export function DynamicInsight({ key, onAdjustment }) {
  const { intakeState } = useContext(IntakeContext)
  const rpqScore = useRPQScore()

  const adjustedRiskLevel = intakeState?.riskAssessment?.manualRiskLevel
  const calculatedRiskLevel = rpqScore?.weightedScore || 0
  const riskLevel = adjustedRiskLevel || calculatedRiskLevel
  const profile = riskProfiles.find((p) => p.riskLevel === riskLevel)
  const {
    displayName,
    subtitle,
    image,
    accentHex,
    description,
    descriptionSecondary,
  } = profile

  const isAdjusted = intakeState?.riskAssessment?.riskProfileAdjusted

  return (
    <Grid key={key} item xs={12}>
      <Box>
        <Box display="flex" alignItems="center" gap={2}>
          <Typography
            sx={{
              fontSize: 24,
              fontWeight: 500,
              color: '#262627',
            }}
          >
            Risk Profile:
          </Typography>
          {isAdjusted && (
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 600,
                color: '#059669',
                backgroundColor: '#D1FAE5',
                padding: '4px 8px',
                borderRadius: 1,
                textTransform: 'uppercase',
                letterSpacing: 0.5
              }}
            >
              Manually Adjusted
            </Typography>
          )}
        </Box>
        <Typography
          sx={{
            fontSize: 32,
            fontWeight: 800,
            color: '#000000',
          }}
        >
          {displayName}
        </Typography>
      </Box>
      <Typography
        mt={2}
        sx={{ color: accentHex, fontSize: 16, fontWeight: 600 }}
      >
        {subtitle}
      </Typography>
      <Typography mt={2} sx={{ fontSize: 16, fontWeight: 500 }}>
        {description}
      </Typography>
      <Typography
        mt={2}
        sx={{ color: '#75787B', fontSize: 16, fontWeight: 400 }}
      >
        {descriptionSecondary}
      </Typography>

      <Box display="flex" alignItems="center" justifyContent="center">
        <img
          src={image}
          alt={displayName}
          style={{ width: '180px', height: '180px', objectFit: 'cover' }}
        />
      </Box>
    </Grid>
  )
}

export default DynamicInsight
